// Components
import Notification from "components/molecules/Notification";

// Hooks
import useTranslate from "hooks/useTranslate";

// Types
import { NotificationType } from "redux/notification/slice";

import "./styles.sass";

type NotificationListMobileProps = {
  notificationList: NotificationType[] | [];
};

const NotificationListMobile = (props: NotificationListMobileProps) => {
  const { notificationList } = props;

  const t = useTranslate();

  return (
    <div className="NotificationListMobile">
      {notificationList.length ? (
        notificationList.map((notification: NotificationType) => {
          return (
            <Notification
              notification={notification}
              key={notification.date + notification.title}
            />
          );
        })
      ) : (
        <div className="NotificationListMobile__empty">
          {t("notification.item.not.exist")}
        </div>
      )}
    </div>
  );
};

export default NotificationListMobile;
